import PropTypes from "prop-types"
import React from "react"
import SemanticLoader from "semantic-ui-react/dist/es/elements/Loader/Loader"
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer/Dimmer"

const Loader = ({ text, active }) => (
  <Dimmer active={active} inverted page>
    <SemanticLoader>{text}</SemanticLoader>
  </Dimmer>
)

Loader.propTypes = {
  text: PropTypes.string,
  active: PropTypes.bool
}

Loader.defaultProps = {
  text: "Loading...",
  active: true
}

export default Loader
